import axios from 'axios';
import apiConfig from '../../api.config';
import constants from '../../../constants';
import storage from '../../../storage';

export default function getHotelInvoiceFileURL(hotelInvoiceId) {
  const {
    host,
    URIs: { getHotelInvoiceFileURL },
  } = apiConfig;

  const uri = `${host}${getHotelInvoiceFileURL}`.replace(':hotelInvoiceId', hotelInvoiceId);

  const storedCredentials = JSON.parse(storage.get(constants.AUTH.USER_KEY));

  return axios
    .post(uri, {
      data: {
        hotelReference: 'civitfun',
        accessToken: storedCredentials.accessToken,
      }
    })
    .then(res => {
      return res.data;
    });
}
